export default __webpack_public_path__ + "static/media/Triology_primary.19cc267d.jpg";